const header = document.querySelector('.js-header');
const links = Array.from(document.querySelectorAll('.js-scroll-smoth'));

links.forEach((link) => {
	link.addEventListener('click', function (e) {
		e.preventDefault();

		const headerHeight = header.offsetHeight;
		const el = document.querySelector(this.getAttribute('href'));

		if (el) {
			window.scroll({
				behavior: 'smooth',
				top: el.offsetTop - headerHeight,
			});
		}
	});
});
